namespace Vit.Administration {
    @Serenity.Decorators.registerClass()
    export class TenantRoleDialog extends Serenity.EntityDialog<UserTenantRoleRow, any> {
        constructor(protected opt?: UserTenantRoleGridDialogOptions) {
            super(opt)
        }

        protected getFormKey() {
            return TenantRoleForm.formKey;
        }

        protected getIdProperty() {
            return UserTenantRoleRow.idProperty;
        }

        protected getLocalTextPrefix() {
            return UserTenantRoleRow.localTextPrefix;
        }

        protected getNameProperty() {
            return UserTenantRoleRow.idProperty;
        }

        protected getService() {
            return UserTenantRoleService.baseUrl;
        }

        protected form = new TenantRoleForm(this.idPrefix);

        //protected afterLoadEntity(): void {
        //    this.form.UserId.value = this.opt.userID.toString();
        //}
        protected validateBeforeSave(): boolean {
            (<any>this.propertyGrid.get_editors()[1]).value = this.opt.userID.toString();
            //if (this.form.UserId) {
            //    this.form.UserId.value = this.opt.userID.toString();
            //}
            //else {
            //    var e = this.getSaveEntity();
            //    e.UserId = this.opt.userID.toString();
            //}
            return true;
        }

    }
}